<template>
    <span>
        <info-icon
            :name="similarityLevelIcon"
            size="0.8em"
            :color="`similarity-${kebabCase(calculatedSimilarityLevel)}`"
            class="q-mr-xs"
        >
            <p><q-circular-progress
                reverse
                :value="Number(similarityScore) * 100"
                size="1em"
                :thickness="0.25"
                :color="`similarity-${kebabCase(calculatedSimilarityLevel)}`"
                track-color="border-primary"
                class="q-mr-xs"
                style="margin-bottom: 0.175em;"
            /> <b>{{ $tc('common.similarity.similarity', 1) }}: {{ formattedSimilarityScore }}</b></p>

            <p>{{ $tc('common.similarity.compared-value-is--similarity-level', 2, { similarityLevel: $tc(`common.similarity.level.${kebabCase(calculatedSimilarityLevel)}`, 1) }) }}</p>

            <div v-if="$slots.value1 || $slots.value2" class="q-mb-sm">
                <p v-if="$slots.value1"><code><slot name="value1" /></code></p>
                <p v-if="$slots.value2"><code><slot name="value2" /></code></p>
            </div>

            <div v-if="$slots.append">
                <slot name="append" />
            </div>
        </info-icon>
    </span>
</template>

<script>
import { computed } from 'vue'
import { kebabCase } from 'lodash'
import { DEFAULT_SIMILARITY_OPTIONS, getSimilarityLevel, formatSimilarityScore, getSimilarityLevelIcon } from '@/helpers/similarity'

export default {
    name: 'SimilarityIndicator',
    props: {
        similarityScore: {
            type: [String, Number],
            required: true,
        },
        threshold: {
            type: Number,
            default: DEFAULT_SIMILARITY_OPTIONS.threshold,
            validator: (value) => value >= 0 && value <= 1,
        },
        verySimilarPercentage: {
            type: Number,
            default: DEFAULT_SIMILARITY_OPTIONS.verySimilarPercentage,
            validator: (value) => value >= 0 && value <= 100,
        },
        somewhatSimilarOffset: {
            type: Number,
            default: DEFAULT_SIMILARITY_OPTIONS.somewhatSimilarOffset,
            validator: (value) => value >= 0 && value <= 1,
        },
    },
    setup (props) {
        const calculatedSimilarityLevel = computed(() => getSimilarityLevel(props.similarityScore))
        const similarityLevelIcon = computed(() => getSimilarityLevelIcon(calculatedSimilarityLevel.value))
        const formattedSimilarityScore = computed(() => formatSimilarityScore(props.similarityScore))

        return {
            calculatedSimilarityLevel,
            formattedSimilarityScore,
            similarityLevelIcon,

            // Functions
            kebabCase,
        }
    },
}
</script>
